import { RadioItem } from './RadioItem';

export class CheckItem extends RadioItem {

}
